export const SECTION_COLORS = [
  {
    id: "blue",
    bg: "#EAF2FD",
    titleColor: "#06255A",
    subtitleColor: "#4B6584",
    iconColor: "#2563EB",
  },
  {
    id: "green",
    bg: "#EAF7EE",
    titleColor: "#1B5E20",
    subtitleColor: "#388E3C",
    iconColor: "#16A34A",
  },
  {
    id: "peach",
    bg: "#FFF4E6",
    titleColor: "#9A3412",
    subtitleColor: "#C2410C",
    iconColor: "#EA580C",
  },
  {
    id: "purple",
    bg: "#F4ECFB",
    titleColor: "#581C87",
    subtitleColor: "#7E22CE",
    iconColor: "#9333EA",
  },
  {
    id: "teal",
    bg: "#E3F7F7",
    titleColor: "#006064",
    subtitleColor: "#00838F",
    iconColor: "#00ACC1",
  },
]

export const getSectionColor = (indexOrId) => {
  if (typeof indexOrId === "number") {
    return SECTION_COLORS[Math.abs(indexOrId) % SECTION_COLORS.length]
  }
  return SECTION_COLORS[0]
}
